import Application from "../../Application";
import ShowSuccessMessageInteractor from "../../core/interactor/notifications/ShowSuccessMessageInteractor";
import { IDocumentType } from "../../documentTypes/model/DocumentType";
import withStore, {
  TLoadingAwarePresenter,
  TPresentable
} from "../../core/presenter/withStore";
import CreateCaseLawDocumentTypeInteractor from "../interactor/CreateCaseLawDocumentTypeInteractor";
import GetAllCaseLawDocumentTypesInteractor from "../interactor/GetAllCaseLawDocumentTypesInteractor";
import UpdateCaseLawDocumentTypeInteractor from "../interactor/UpdateCaseLawDocumentTypeInteractor";

export interface TCaseLawDocumentTypeListPresenter
  extends TLoadingAwarePresenter {
  caseLawDocumentTypes: IDocumentType[];
}

export interface ICaseLawDocumentTypeListPresenter
  extends TCaseLawDocumentTypeListPresenter,
    TPresentable {
  loadAllCaseLawDocumentTypes(caseLawDocumentTypes: IDocumentType[]): void;
  createCaseLawDocumentType(data: IDocumentType): void;
  updateCaseLawDocumentType(data: IDocumentType): void;
}

const defaultState: TCaseLawDocumentTypeListPresenter = {
  caseLawDocumentTypes: []
};

const CaseLawDocumentTypeListPresenter = withStore<
  ICaseLawDocumentTypeListPresenter,
  TCaseLawDocumentTypeListPresenter
>(
  ({
    application,
    store,
    loader,
    translate
  }): ICaseLawDocumentTypeListPresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<TCaseLawDocumentTypeListPresenter>();
    loader.start("caseLawDocumentTypeLoader");
    const loadAllCaseLawDocumentTypes = (
      caseLawDocumentTypes: IDocumentType[]
    ) => {
      _store.update({ caseLawDocumentTypes });
      loader.stop("caseLawDocumentTypeLoader");
    };

    const getAllCaseLawDocumentTypes = async () => {
      let caseLawDocumentTypes = await _application.container
        .resolve<GetAllCaseLawDocumentTypesInteractor>(
          "getAllCaseLawDocumentTypes"
        )
        .execute();
      loadAllCaseLawDocumentTypes(caseLawDocumentTypes);
    };

    const createCaseLawDocumentType = async (
      caseLawDocumentType: IDocumentType
    ) => {
      await _application.container
        .resolve<CreateCaseLawDocumentTypeInteractor>(
          "createCaseLawDocumentType"
        )
        .execute(caseLawDocumentType);
      _application.container
        .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
        .execute(translate("editors.project_member.create_success_message"));

      await getAllCaseLawDocumentTypes();
    };
    const updateCaseLawDocumentType = async (
      caseLawDocumentType: IDocumentType
    ) => {
      await _application.container
        .resolve<UpdateCaseLawDocumentTypeInteractor>(
          "updateCaseLawDocumentType"
        )
        .execute(caseLawDocumentType);
      _application.container
        .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
        .execute(translate("editors.project_member.create_success_message"));

      await getAllCaseLawDocumentTypes();
    };

    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      loadAllCaseLawDocumentTypes,
      createCaseLawDocumentType,
      updateCaseLawDocumentType
    };
  },
  defaultState
);

export default CaseLawDocumentTypeListPresenter;
